export default "__VITE_ASSET__77VXY5fa__"